import { render } from "./Error.vue?vue&type=template&id=62ea582a&scoped=true"
import script from "./Error.vue?vue&type=script&lang=ts"
export * from "./Error.vue?vue&type=script&lang=ts"

import "./Error.vue?vue&type=style&index=0&id=62ea582a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-62ea582a"

export default script